export default {
  ROSTERING_TEACHER: {
    image: require('assets/images/organizations/OrganizationUpsellHeader/value-props/rostering.svg'),
    title: 'Classes created for you',
    subtext:
      'Reach more students and parents with classes created—and filled—by your school roster system.',
  },
  LONG_MESSAGES: {
    image: require('assets/images/organizations/OrganizationUpsellHeader/value-props/long-messages.svg'),
    title: 'No more 140-character limit',
    subtext:
      'Send the messages you want to send. With a School Plan, you can compose longer messages for your classes.',
  },
  VOICE_CALLS: {
    image: require('assets/images/organizations/OrganizationUpsellHeader/value-props/voice-calls.svg'),
    title: 'Make a call to any phone',
    subtext:
      'Up-to-date contact information makes calling easy, and automatic logging helps you keep track of your calls.',
  },
  ADMINISTRATION: {
    image: require('assets/images/organizations/OrganizationUpsellHeader/value-props/analytics.svg'),
    title: 'Oversight and administration',
    subtext: 'See, understand, and manage who’s in your organization on Remind.',
  },
  ADMINISTRATOR_COMMUNICATION: {
    image: require('assets/images/organizations/OrganizationUpsellHeader/value-props/long-and-calls.svg'),
    title: 'Administrator communication',
    subtext:
      'Reach everyone in your community with organization-wide messaging, urgent messaging, and more.',
  },
  ONBOARDING: {
    image: require('assets/images/organizations/OrganizationUpsellHeader/value-props/rostering.svg'),
    title: 'Simple, effective onboarding',
    subtext:
      'Automatically create accounts and classes with data from your student information system.',
  },
  AUTO_MESSAGE_TRANSFER_DATA: {
    image: require('assets/images/admin/AdminAutoMessages/schedule.svg'),
    title: 'Start transferring data',
    subtext: 'Send CSV files containing recipient student numbers to Remind via SFTP',
  },
  AUTO_MESSAGE_COMPOSE_AND_REVIEW: {
    image: require('assets/images/admin/AdminAutoMessages/compose.svg'),
    title: 'Compose and review',
    subtext: 'Specify who the message should come from and what it should say',
  },
  AUTO_MESSAGE_GO_LIVE: {
    image: require('assets/images/admin/AdminAutoMessages/activate.svg'),
    title: 'Go live',
    subtext: 'Messages will send automatically every time the right CSV is received',
  },
  START_SIS_SYNC_FORMAT_FILES: {
    image: require('assets/images/rostering/1-format-files.png'),
    title: 'Format CSV files',
    subtext: 'Learn how to properly format CSV files from your SIS in a test environment.',
  },
  START_SIS_SYNC_LIST_FORMAT_FILES: {
    image: require('assets/images/rostering/1-format-files.png'),
    title: 'Choose sync type',
    subtext: 'Prepare school data in Classlink, OneRoster and Remind CSV 2.0 formats.',
  },
  START_SIS_SYNC_SETUP: {
    image: require('assets/images/rostering/2-computer-transfer.png'),
    title: 'Setup SFTP sync',
    subtext: 'Transfer your formatted files to Remind and match your schools.',
  },
  START_SIS_SYNC_SEND_DATA: {
    image: require('assets/images/rostering/2-computer-transfer.png'),
    title: 'Send data to Remind',
    subtext: 'Initiate the first sync of school data to Remind through Classlink or SFTP.',
  },
  START_SIS_SYNC_REVIEW: {
    image: require('assets/images/rostering/3-standing-coffee.png'),
    title: 'Review and push data live',
    subtext: 'Our team will review your files and confirm readiness to roster your community.',
  },
};
